import { Api, IApiResponse } from '../api';
import { ProfileDto } from '../models';

const getAll = (): Promise<IApiResponse<ProfileDto[]>> => Api.get('Profiles');

const getMine = (accessToken?:string): Promise<IApiResponse<ProfileDto[]>> => Api.get('Profiles/me', accessToken);

export { getAll, getMine };
